import styled from 'styled-components';

export const ThumbUpStyled = styled.span`
    position: absolute;
    left: -4px;
    top: -4px;
    z-index: 2;
`;

export const ThumbDownStyled = styled.span`
    position: absolute;
    left: 4px;
    top: 4px;
    z-index: 1;
`;

